<template>
    <div class="main-layout">
        <side-menu v-model="sideMenuOpen"
            v-click-outside="handleMenuClickOutside">
        </side-menu>
        <div class="page-wrapper"
            :class="{
                'side-menu-open': sideMenuOpen,
            }">
             <!-- 'admin-view': isAdmin -->
            <div class="content-wrapper">
                <nav class="top-navigation">
                    <button class="btn btn-menu side-menu-toggle"
                        @click="toggleSideMenu">
                        <div class="btn-menu-icon"
                            :style="{
                                'background-image': `url(${menuBurgerIcon})`
                            }">
                        </div>
                        <div class="btn-menu-text">Menu</div>
                    </button>
                    <div class="nav-spacer">
                    </div>
                    <div v-if="!$store.state.user.email" class="nav-login-signup">
                        <!-- <router-link :to="{
                            'name': 'register'
                        }">
                            Register New Account
                        </router-link> -->

                        <router-link :to="{
                            'name': 'login'
                        }">
                            Login
                        </router-link>
                    </div>
                    <template v-else>
                        <div class="dropdown">
                            <div class="mr-3">
                                {{usernameOrEmailDisplay}}
                            </div>
                            <!-- <button class="btn btn-dropdown-menu dropdown-toggle"
                                type="button"
                                id="dropdownUser"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">

                            </button> -->
                            <!-- <div class="dropdown-menu" aria-labelledby="dropdownUser">
                                <router-link :to="{
                                    'name': 'change-password'
                                }"
                                    class="dropdown-item">
                                    Change Password
                                </router-link>
                            </div> -->
                        </div>
                        <div>
                            <a href="javascript: void(0);"
                                class="btn btn-secondary btn-logout"
                                @click="logoutUser">
                                Logout
                            </a>
                        </div>
                    </template>
                </nav>

                <div class="page-content-wrapper">
                    <!-- <div class="page-title">{{pageTitle}}</div> -->
                    <div class="page-container">
                        <div v-if="withoutPageWrapper">
                            <router-view/>
                        </div>
                        <div v-else class="page-content">
                            <!-- <div class="mb-4 text-center">
                                <img src="/static/campaigns/boost_ipay88.png" class="img-fluid">
                            </div> -->
                            <router-view/>
                        </div>
                    </div>
                    <div class="privacy-policy-view text-center pb-3">
                        <a target="_blank" :href="companyPrivacyPolicyUrl">Privacy Policy</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="unauthorizedModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="unauthorizedModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        {{unauthorizedText}}
                    </h5>
                </div>
                <div class="modal-body">
                    Please login to continue.
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="redirectToLogin">Login</button>
                </div>
                </div>
            </div>
        </div>
        <!-- <chat-widget></chat-widget> -->
    </div>
</template>

<script>
import $ from 'jquery';
// import moment from 'moment';
import ClickOutside from 'vue-click-outside';
import viewport from 'viewport-dimensions';
import menuBurgerSvg from '@/assets/img/icons/menu_burger.svg';
import SideMenu from './side-menu';
import ChatWidget from '@/components/chat-widget';
import { userSideMenus } from '@/routes';
import { EventBus } from '@/events/';
import Cookies from 'js-cookie';
export default {
    'name': 'Layout',
    'components': {
        SideMenu,
        ChatWidget
    },
    'directives': {
        ClickOutside
    },
    created () {
        EventBus.$on('notLogIn', () => {
            this.showNotLoggedInModal();
        });
    },
    'computed': {
        companyNameOfficial () {
            return this.$store.state.operator.companyNameOfficial;
        },
        companyRegistrationNumber () {
            return this.$store.state.operator.companyRegistrationNumber;
        },
        companyPrivacyPolicyUrl () {
            return this.$store.state.operator.privacyPolicyUrl;
        },
        menuBurgerIcon () {
            return menuBurgerSvg;
        },
        // pageTitle () {
        //     return this.$store.state.app.pageTitle;
        // },
        usernameOrEmailDisplay () {
            return this.$store.state.user.userName ? this.$store.state.user.userName : this.$store.state.user.email;
        },
        withoutPageWrapper () {
            return this.$route.meta ? this.$route.meta.withoutPageWrapper : false;
        },
        // isAdmin () {
        //     return this.$store.state.user.userRole === 1;
        // },
        appIsAuthenticated () {
            return !this.$store.state.isPublic;
        },
        authenticatedAccountType () {
            return this.$store.state.user.accountType;
        },
        authenticatedUserRole () {
            return this.$store.state.user.userRole;
        },
        unauthorizedText () {
            return 'Login Required';
        },
        isLoginPromptedPreviously () {
            return this.$store.state.isNotifiedNotLoggedIn;
        },
        shouldSendHeartbeat () {
            return this.$store.getters.shouldSendHeartbeat;
        },
        thisYear () {
            return new Date().getFullYear();
        }
    },
    'watch':
    {
        pageWidth () {
            this.detectIsMobile();
        },
        isMobile (val) {
            this.handleSideMenuDefault(val);
        },
        $route (val) {
            // closes side menu if it's mobile mode
            if (this.isMobile) {
                this.sideMenuOpen = false;
            }
        },
        appIsAuthenticated (isAuthenticated) {
            if (isAuthenticated) {
                document.body.classList.add('authenticated');
            } else {
                document.body.classList.remove('authenticated');
            }

            this.$nextTick(() => {
                this.setupSideMenu();
            });
        },
        shouldSendHeartbeat (val) {
            if (val) {
                this.sendHeartbeat();
            }
        }
    },
    data () {
        return {
            'sideMenuOpen': true,
            'pageWidth': 0,
            'isMobile': false
        };
    },
    mounted () {
        this.detectWidthChange();
        this.detectIsMobile();
        this.handleSideMenuDefault(this.isMobile);
        window.addEventListener('resize', this.detectWidthChange);
        window.addEventListener('orientationchange', this.detectWidthChange);

        // this.getLoginStatus();
    },
    destroyed () {
        window.removeEventListener('resize', this.detectWidthChange);
        window.removeEventListener('orientationchange', this.detectWidthChange);
    },
    'methods': {
        detectWidthChange () {
            this.pageWidth = viewport.width();
        },
        detectIsMobile () {
            if (this.pageWidth < 992) {
                this.isMobile = true;
            } else {
                this.isMobile = false;
            }

            this.$store.commit('setIsMobile', this.isMobile);
        },
        handleSideMenuDefault (isMobile) {
            if (isMobile) {
                this.sideMenuOpen = false;
            } else {
                if (!this.sideMenuOpen) {
                    this.sideMenuOpen = true;
                }
            }
        },
        toggleSideMenu () {
            this.sideMenuOpen = !this.sideMenuOpen;
        },
        handleMenuClickOutside (event) {
            let menuToggleButton = document.querySelector('.side-menu-toggle');
            let menuToggleNodes = [];
            menuToggleNodes.push(menuToggleButton);

            menuToggleButton.childNodes.forEach((node) => {
                menuToggleNodes.push(node);
            });

            if (!(menuToggleNodes.some((dom) => dom === event.target)) && this.isMobile && this.sideMenuOpen) {
                this.sideMenuOpen = false;
            }
        },
        getLoginStatus () {
            // this.axiosInstance.get('account/GetAccountState')
            //     .then((res) => {
            //         // set !appIsAuthenticated = false
            //         this.$store.commit('setAppStatus', false);
            //         this.$store.commit('setUserDetails', res.data);
            //     })
            //     .catch((error) => {
            //         if (error.response && error.response.status === 401) {
            //             // set !appIsAuthenticated = false
            //             this.$store.commit('setAppStatus', true);
            //         } else {
            //             console.log(error);
            //         }
            //     });
        },
        logoutUser () {
            // Remove token
            Cookies.remove('t');
            this.axios.defaults.headers.common = {};

            this.$store.commit('setAppStatus', true);
            this.$store.commit('setSideMenuList', []);
            this.axios.get('account/logout')
                .finally(() => {
                    this.$store.commit('setAppStatus', true);
                    this.$store.commit('clearUserState');
                    this.$router.push({
                        'name': 'login'
                    });
                });
        },
        showNotLoggedInModal () {
            this.$store.commit('setAppStatus', true);
            this.$store.commit('clearUserState');
            this.$store.commit('setSideMenuList', []);
            if (!this.isLoginPromptedPreviously && this.$route.name !== 'login') {
                this.$store.commit('updateLoginPromptStatus', true);
                $('#unauthorizedModal').modal('show');
            }
        },
        setupSideMenu () {
            let sideMenuList = this.getUserSideMenu();

            this.$store.commit('setSideMenuList', sideMenuList);
        },
        getUserSideMenu () {
            if (this.appIsAuthenticated) {
                // switch (this.authenticatedAccountType) {
                // case 1: // user
                //     // check user type
                //     switch (this.authenticatedUserRole) {
                //     case 1:
                //         return userSideMenus.userSideMenu;
                //     case 998:
                //         return userSideMenus.iphAdminSideMenu;
                //     case 999:
                //         return userSideMenus.superAdminSideMenu;
                //     }
                //     break;
                // case 2: // doctor
                //     return userSideMenus.doctorSideMenu;
                // case 3: // pharmacy
                //     switch (this.authenticatedUserRole) {
                //     case 1:
                //         return userSideMenus.pharmacyUserSideMenu;
                //     case 99:
                //         return userSideMenus.pharmacyAdminSideMenu;
                //     }
                //     break;
                // case 4: // company
                //     return userSideMenus.companyAdminSideMenu;

                // case 5: // clinic demo
                //     return userSideMenus.clinicSideMenu;

                // case 6: // clinic doctor
                //     return userSideMenus.clinicDoctorSideMenu;

                // case 7:
                //     return userSideMenus.tpaSideMenu;

                // case 8: // clinic nurse
                //     return userSideMenus.clinicNurseSideMenu;
                // }
                switch (this.authenticatedUserRole) {
                case 1: // user
                    return userSideMenus.userSideMenu;
                case 2: // doctor
                    return userSideMenus.doctorSideMenu;
                case 3: // pharmacy
                    return userSideMenus.pharmacyAdminSideMenu;
                case 4: // company
                    return userSideMenus.companyAdminSideMenu;
                case 5: // clinic demo
                    return userSideMenus.clinicSideMenu;
                case 6: // clinic doctor
                    return userSideMenus.clinicDoctorSideMenu;
                case 7: // clinic nurse
                    return userSideMenus.clinicNurseSideMenu;
                case 8: // super admins
                    return userSideMenus.superAdminSideMenu;
                case 9: // iph admin
                    return userSideMenus.iphAdminSideMenu;
                case 10: // vaccination centre
                    return userSideMenus.vaccinationCentreSideMenu;
                }
            }

            return userSideMenus.publicSideMenu;
        },
        redirectToLogin () {
            this.$store.commit('setAppStatus', true);
            this.axios.get('account/logout')
                .finally(() => {
                    // Remove token
                    Cookies.remove('t');
                    this.axios.defaults.headers.common = {};

                    $('#unauthorizedModal').modal('hide');
                    this.$store.commit('setAppStatus', true);
                    this.$store.commit('clearUserState');
                    this.$store.commit('updateLoginPromptStatus', false);
                    let queryReturn = {};

                    if (this.$route.name !== 'login') {
                        queryReturn.from = window.location.href;

                        this.$router.push({
                            'name': 'login',
                            'query': queryReturn
                        });
                    }
                });
        },
        sendHeartbeat () {
            if (this.shouldSendHeartbeat) {
                // console.log('heartbeat');
                setTimeout(() => {
                    this.axios.get('Account/Heartbeat').then(() => {
                        this.sendHeartbeat();
                    });
                }, 1000 * 20);
            }
        }
    }
};
</script>

<style>
:root
{
    --top-nav-height: 64px;
    --side-menu-width: 250px;
}

.main-layout
{
    width: 100%;
    overflow-x: hidden;
    min-height: 100vh;
}

.main-layout .top-navigation
{
    position: fixed;
    left: 0px;
    right: 0;
    display: flex;
    height: 64px;
    align-items: center;
    color: #272a30;
    background-color: #fff;
    box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
    transition: 0.2s left ease-in-out;
    z-index: 5;
}

@media (max-width: 575px)
{
    .main-layout .top-navigation
    {
        width: 100vw;
    }
}

.main-layout .top-navigation .btn-menu
{
    display: flex;
    align-items: center;
    padding: 6px 8px;
    margin: 2px 5px 0 5px;
    background-color: transparent;
    transition: 0.2s opacity ease-in-out;
}

.main-layout .top-navigation .btn-menu:active
{
    opacity: .5;
}

.main-layout .top-navigation .btn-menu:focus
{
    box-shadow: none;
}

.main-layout .top-navigation .btn-menu > .btn-menu-icon
{
    width: 24px;
    height: 24px;
    background-size: 24px 24px;
    background-position: top left;
    background-repeat: no-repeat;
}

.main-layout .top-navigation .btn-menu > .btn-menu-text
{
    margin-left: 10px;
}

@media(min-width: 992px)
{
    .main-layout .top-navigation .btn-menu
    {
        display: none;
    }
}

@media(min-width: 576px) {
    .main-layout .top-navigation .btn-menu
    {
        padding: 6px 8px;
        margin: 2px 10px 0 10px;
    }
}

.main-layout .top-navigation .nav-spacer
{
    flex: 1;
}

.main-layout .top-navigation .btn-dropdown-menu
{
    height: 64px;
    border-radius: 0;
    margin-right: 10px;
    background-color: transparent;
    font-size: 1rem;
}

@media (max-width: 370px)
{
    .main-layout .top-navigation .btn-dropdown-menu
    {
        max-width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 5px;
        padding: 5px 5px;
    }
}

@media (max-width: 575px)
{
    .main-layout .top-navigation .btn-dropdown-menu
    {
        font-size: .8rem;
    }

    .main-layout .top-navigation .btn-menu > .btn-menu-text
    {
        font-size: .8rem;
    }
}

.main-layout .top-navigation .btn-dropdown-menu:focus
{
    box-shadow: none;
}

.main-layout .top-navigation .btn-logout
{
    margin-right: 20px;
}

.main-layout .top-navigation .nav-login-signup
{
    margin-right: 20px;
}

.main-layout .top-navigation .nav-login-signup a:not(:last-child)
{
    margin-right: 15px;
}

.main-layout > .page-wrapper
{
    width: 100%;
    overflow-x: hidden;
    min-height: 100vh;
    background-color: #f3f3f4;
    padding-left: 0;
    transition: 0.2s padding ease-in-out;
}

.main-layout > .page-wrapper.side-menu-open
{
    padding-left: 250px;
}

.main-layout > .page-wrapper.side-menu-open .top-navigation
{
    left: 250px;
}

.main-layout > .page-wrapper .content-wrapper
{
    position: relative;
    background-color: #f3f3f4;
    min-height: 100vh;
}

.main-layout > .page-wrapper .content-wrapper > .page-content-wrapper
{
    padding-top: 64px;
}

@media (max-width: 575px)
{
    .main-layout > .page-wrapper .content-wrapper > .page-content-wrapper
    {
        width: 100vw;
    }
}

.page-title
{
    height: 80px;
    line-height: 80px;
    font-weight: 300;
    font-size: 1.5rem;
    padding: 0 20px;
    background-color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.page-container
{
    padding: 1rem;
}

.page-container.consultation
{
    padding: 0;
}

.page-content
{
    padding: 1rem;
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
    background-color: #fff;
    transition: 0.2s all ease-in-out;
    overflow: auto;
}

.page-content.consultation {
    padding: 0;
    margin: 0;
    max-width: 100vw;
}

.page-content.wide-version {
    padding: 1rem !important;
    max-width: none;
}

@media (min-width: 576px)
{
    .page-content
    {
        padding: 3rem;
    }
}

.admin-view .page-content {
    padding: 1rem !important;
    max-width: none;
}

.admin-view table {
    font-size: 13px;
}

.btn-popover-dismiss {
    position: absolute;
    right: 0;
    top: 0;
    height: 36px;
    width: 36px;
    font-size: 1.5rem;
}

body.no-top-navigation .top-navigation {
    display: none !important;
}

body.no-top-navigation .page-content-wrapper {
    padding-top: 0 !important;
}

body.no-top-navigation .privacy-policy-view {
    display: none !important;
}

</style>
